import { render } from "./RegionVKO.vue?vue&type=template&id=669b7654&ts=true"
import script from "./RegionVKO.vue?vue&type=script&lang=ts"
export * from "./RegionVKO.vue?vue&type=script&lang=ts"

import "./RegionVKO.vue?vue&type=style&index=0&id=669b7654&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__